import script from "./MyEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./MyEditor.vue?vue&type=script&setup=true&lang=js"

import "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__